<template>
  <span v-if="subtitleProps">
    <!-- Group pricing: loaded or skeleton with "per person" -->
    <template v-if="subtitleProps.variant === 'group'">
      <span
        v-if="subtitleProps.formattedSubtitle"
        v-html="subtitleProps.formattedSubtitle"
      />
      <span v-else class="flex items-center gap-1 mt-0.5">
        <span
          v-if="subtitleProps.hasSale"
          class="inline-block w-14 h-4 bg-gray-200 rounded animate-pulse"
        />
        <span class="inline-block w-14 h-4 bg-gray-200 rounded animate-pulse" />
        {{ t(subtitleProps.perPersonKey) }}
      </span>
    </template>

    <!-- Tiered pricing -->
    <span
      v-else-if="subtitleProps.variant === 'tiered'"
      class="flex items-center gap-1 text-teal-600"
    >
      <IconTags class="w-4 h-4" />
      {{ subtitleProps.fromPricePerPerson }}
    </span>

    <!-- Standard / Kit pricing -->
    <span
      v-else-if="subtitleProps.variant === 'standard'"
      v-html="subtitleProps.formattedSubtitle"
    />
  </span>
</template>

<script lang="ts" setup>
import IconTags from '~/assets/icons/tags.svg?component'
import type { SubtitleProps } from '~/composables/eventBuyBoxPrice'

defineProps<{
  subtitleProps: SubtitleProps
}>()

const { t } = useI18n()
</script>
